// extracted by mini-css-extract-plugin
module.exports = {"background":"press-banner-module--background--r6rfZ","container":"press-banner-module--container--31jYT","title":"press-banner-module--title--2MqPb"};